<template>
  <div id="paginaRiepilogoContratti">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Grid View: GridElencoProduzioni -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Riepiloghi Enpals</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">

                <ejs-grid id="gridA" ref="gridA" :dataSource="riepiloghiEnpalsFullData" :allowSorting="true"
                  :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                  :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                  :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete"
                  :queryCellInfo='gridAqueryCellInfo'>
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30"></e-column>
                    <e-column field="soggetto" headerText="Soggetto" width="60"></e-column>
                    <e-column field="produzione" headerText="Produzione" width="60"></e-column>
                    <e-column field="compenso" headerText="Compenso" width="60"></e-column>
                    <e-column field="costoDitta" headerText="Costo Ditta" width="60"></e-column>
                    <e-column field="totale" headerText="Totale" width="60"></e-column>
                    <e-column field="stato" headerText="Stato" width="100" editType='dropdownedit'
                      :edit='editparams'></e-column>
                    <e-column field="validato" headerText="Validato" width="60" textAlign="Center"
                      displayAsCheckBox="true" type="boolean" editType='booleanedit'></e-column>

                    <e-column headerText='Commands' width=120 :commands='commands'></e-column>

                    </e-column>
                    </e-column>
                  </e-columns>
                </ejs-grid>

              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>


  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin, CarouselPlugin, FormRatingPlugin,
} from 'bootstrap-vue'
// import Vuexy
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data';
// import {
//   extend, addClass, createElement, isNullOrUndefined, detach, EventHandler,
// } from '@syncfusion/ej2-base'
import {
  DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin,
} from '@syncfusion/ej2-vue-calendars'
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, SliderPlugin, UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import {
  RichTextEditorPlugin, Link, Image, Count, HtmlEditor, QuickToolbar, Toolbar as RTToolbar,
} from '@syncfusion/ej2-vue-richtexteditor' // rinominato Toolbar RTToolbar incomp con Word
import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet'
import {
  SchedulePlugin, Day, Week, WorkWeek, Month, Agenda,
} from '@syncfusion/ej2-vue-schedule'
import { DocumentEditorContainerPlugin, DocumentEditorContainerComponentm, Toolbar } from '@syncfusion/ej2-vue-documenteditor'
import {
  PdfViewerPlugin, Magnification, Navigation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch, Annotation, FormFields, FormDesigner, Toolbar as PDFToolbar,
} from '@syncfusion/ej2-vue-pdfviewer' // rinominato Toolbar PDFToolbar incomp con Word
import { KanbanPlugin } from '@syncfusion/ej2-vue-kanban'
import {
  GanttPlugin, Edit, Filter, Sort,
} from '@syncfusion/ej2-vue-gantt'
import { DiagramPlugin } from '@syncfusion/ej2-vue-diagrams'
import {
  MapsPlugin, Bubble, Zoom, MapsTooltip, Marker, NavigationLine,
} from '@syncfusion/ej2-vue-maps'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter, CommandColumn
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(EmbedPlugin)
Vue.use(TablePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(CarouselPlugin)
Vue.use(FormRatingPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(SliderPlugin)
Vue.use(UploaderPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(RichTextEditorPlugin)
Vue.use(SpreadsheetPlugin)
Vue.use(SchedulePlugin)
Vue.use(DocumentEditorContainerPlugin)
Vue.use(PdfViewerPlugin)
Vue.use(KanbanPlugin)
Vue.use(GanttPlugin)
Vue.use(DiagramPlugin)
Vue.use(MapsPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ListBoxPlugin)
enableRipple(true)
// api
// const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT
// //const apiProduzioniUrl = '/demo/api/artista'
// const apiProduzioniUrl = '/demo/api/soggetto'
// const apiDocProduzioniUrl = '/demo/api/docartista' // non lo chiamo per ora
// const apiImgproduzioniUrl = '/demo/api/imgartista' // non lo chiamo per ora

const stati = [
  { statiName: 'Trasmesso', statiId: 'Trasmesso' },
  { statiName: 'Da Trasmettere', statiId: 'Da Trasmettere' },
]


export default Vue.extend({
  components: {
  },
  data() {
    return {
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      // riepiloghiEnpals
      riepiloghiEnpalsFullData: [
        {
          id: 1,
          soggetto: "Mario Rossi",
          produzione: "Tosca",
          compenso: 1000,
          costoDitta: 1500,
          totale: 0,
          validato: true,
          stato: "Da Trasmettere"
        },
        {
          id: 2,
          soggetto: "Serena Autieri",
          produzione: "Tosca",
          compenso: 2000,
          costoDitta: 3000,
          totale: 0,
          validato: false,
          stato: "Da Trasmettere"
        },
        {
          id: 3,
          soggetto: "Makil Abmus",
          produzione: "Bullo",
          compenso: 500,
          costoDitta: 800,
          totale: 0,
          validato: false,
          stato: "Trasmesso"
        },
      ], // elenco completo dati produzioni
      riepiloghiEnpalsActiveId: 0, // Id soggetto attivo (0 se nuovo)
      riepiloghiEnpalsActiveData: {}, // dati completi dell soggetto attivo
      riepiloghiEnpalsSavedData: {}, // dati completi dell soggetto attivo
      riepiloghiEnpalsDefaultData: {}, // dati completi di default per nuovi produzioni
      riepiloghiEnpalsRuoliList: [], // elenco 
      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,
      // per gridA
      editparams: {
        params: {
          allowFiltering: true,
          dataSource: stati,
          fields: { text: 'statiName', value: 'statiId' },
          query: new Query(),
          actionComplete: () => false,
          popupHeight: '400px',
        },
      },
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
          allowAdding: true,
          mode: "Normal"
          //mode: "Batch"
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          // {
          //   text: 'Nuova Produzione', tooltipText: 'Inserisci nuovo soggetto', prefixIcon: 'e-plus', id: 'newPR',
          // },
          // {
          //   text: 'Modifica Produzione', tooltipText: 'Modifica soggetto', prefixIcon: 'e-expand', id: 'edit',
          // },
          // {
          //   text: 'Cancella Produzione', tooltipText: 'Cancella soggetto', prefixIcon: 'e-cancel', id: 'delete',
          // },
          'Search',
        ],
      }, //
      commands: [{ type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
      { type: 'Delete', buttonOption: { cssClass: 'e-flat', iconCss: 'e-delete e-icons' } },
      { type: 'Save', buttonOption: { cssClass: 'e-flat', iconCss: 'e-update e-icons' } },
      { type: 'Cancel', buttonOption: { cssClass: 'e-flat', iconCss: 'e-cancel-icon e-icons' } }],


    }
  },
  created() {
    console.log('Pagina Riepiloghi Enpals Creata')
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, CommandColumn],
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create()
      uninterceptedAxiosInstance.get(url,
        {
          responseType: 'arraybuffer',
          crossdomain: true,
        }).then(response => {
          this.forceFileDownload(response, title)
        }).catch(() => console.log('error occured'))
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === 'newPR') {
        this.dialogA1.header = 'Nuovo soggetto fisico'
        this.produzioniDefaultData = {
          id: 0,
          tipoSoggetto: 'PersonaFisica',
          nome: '',
          cognome: '',
          ragioneSociale: '-',
          dataNascita: null,
          luogoNascita: '',
          nazionalita: 'eu',
          codiceFiscale: '',
          numeroTelefono: '',
          altezza: null,
          peso: null,
          ratingEsperienza: 0,
          ratingPerformance: 0,
          immagineProfilo: 'https://picsum.photos/1024/400/?image=51',
          documenti: [],
          documentiSelezionati: [],
          agente: null,
          under35: false,
          ruoliAbilitati: [],
        }
        this.produzioniActiveData = this.produzioniDefaultData
        console.log('Premuto pulsante creazione nuovo soggetto fisico da gridA')
        // console.log(this.produzioniActiveData);
        // console.log(this.produzioniDefaultData);
        this.produzioniActiveId = 0
        this.$refs.dialogA1.show(true)
      }
      // pulsante EDIT 
      else if (args.item.id === 'edit') {
        this.dialogA1.header = 'Modifica Produzione'
        console.log('Premuto pulsante modifica soggetto da gridA')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          let found = false
          this.produzioniActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          console.log(this.produzioniActiveId)
          for (const i in this.produzioniFullData) {
            if (this.produzioniFullData[i].id === this.produzioniActiveId) {
              // console.log("id dell'elenco trovato:")
              // console.log('SOGGETTO CORRENTE')
              // console.log(this.produzioniFullData[i])
              this.produzioniActiveData = { ...this.produzioniFullData[i] }
              found = true
              break
            }
          }
          console.log('SOGGETTO CORRENTE')
          console.log(this.produzioniActiveData)
          console.log(this.produzioniActiveId)

          // // aggiorno informazioni relative ad immagine profilo soggetto
          // // devo partire dall'elenco degli produzioni
          // if (this.produzioniActiveId !== 0) {
          //   const list4 = this.produzioniFullData // lista di origine
          //   const ids4 = [this.produzioniActiveId] // elementi da cercare
          //   const newArr4 = list4.filter(item => ids4.includes(item.id)) // 

          //   console.log('SOGGETTO')
          //   console.log(newArr4) // questo e' il soggetto
          //   const curSoggetto = newArr4[0]
          //   if (curSoggetto.immagineProfilo != null) {
          //     this.produzioniActiveData.immagineProfilo = curSoggetto.immagineProfilo.fileImmagine // assegna risultato ricerca a struttura activeData
          //     console.log(this.produzioniActiveData.immagineProfilo)
          //     this.imgProduzioniActiveData = curSoggetto
          //   } else {
          //     this.produzioniActiveData.immagineProfilo = this.imgProduzioniDefaultData.fileImmagine
          //     this.imgProduzioniActiveData = this.imgProduzioniDefaultData
          //     console.log('IMAGINE PROFILO NON IMPOSTATA')
          //     console.log(this.produzioniActiveData.immagineProfilo)
          //     console.log(this.imgProduzioniActiveData)
          //   }
          // }

          if (found) {
            // produzione
            console.log('Edit produzione')
            this.$refs.dialogA1.show(true)
          }
          else { console.log('Elemento non trovato') }
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
      // Pulsante DELETE 
      else if (args.item.id === 'delete') {
        try {
          console.log('Premuto pulsante elimina soggetto da gridA')
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id

          const deleteUrl = `${apiProduzioniUrl}/${deletedElementId}`
          this.$refs.gridA.ej2Instances.deleteRecord()

          useJwt.delete(deleteUrl).then(res => {
            console.log('Eliminazione avvenuta con successo')
            // console.log(res.data)
          })
        } catch (err) {
          // da sistemare..............
          console.log(err)
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(args) {
      if (args.requestType === 'save') {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false
      }
      if (args.requestType === "beginEdit") {
        // riesco a triggerare dei calcoli cambiando le celle di testo, ma non se cambio le colonne dropdown o checkbox
        // riesco però a leggere i valori di dropdown e checkbox, per poterli usare nel trigger di celle di testo 
        // riesco ad aggiornare il valore di celle di testo, ma non di checkbox e dropdown
        var columnCompensoId = 3;
        var columnCostoDittaId = 4;
        var columnTotaleId = 5;
        var columnStatoId = 6;
        var columnValidatoId = 8; // attenzione, salta di uno!!!
        var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
        // Gestione aggiornamenti da modifiche della colonna "Compenso"
        grid.editModule.formObj.element[columnCompensoId].addEventListener("keyup", function (e) {
          //var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var compenso = +grid.editModule.formObj.element[columnCompensoId].value; // leggo il valore della cella di testo
          var costoDitta = +grid.editModule.formObj.element[columnCostoDittaId].value;
          var myDropElem = grid.editModule.formObj.element[columnStatoId];
          var stato = myDropElem.options[myDropElem.selectedIndex].value; // leggo il valore della cella dropdown (in alternativa posso ottenere il testo con .text al posto di .value)
          var validato = grid.editModule.formObj.element[columnValidatoId].value; // leggo il valore della cella checkbox
          //var totale = compenso + costoDitta; // versione reale
          // implemento un esempio dove la formula cambia in base al valore dell'elenco e del checkbox
          if (stato == "Trasmesso") {
            if (validato === 'true') {
              var totale = 10 * (compenso + costoDitta);
              console.log("Validato e Trasmesso");
              console.log(totale);
              grid.editModule.formObj.element[columnTotaleId].value = totale;
            }
            else {
              var totale = 1 * (compenso + costoDitta);
              console.log("Non Validato e Trasmesso");
              console.log(totale);
              console.log(validato);
              grid.editModule.formObj.element[columnTotaleId].value = totale;
            }
          }
          else {
            var totale = 0;
            console.log("Non Trasmesso");
              console.log(totale);
            grid.editModule.formObj.element[columnTotaleId].value = totale;
          }
        });
        // Gestione aggiornamenti da modifiche della colonna "Costo Ditta"
        grid.editModule.formObj.element[columnCostoDittaId].addEventListener("keyup", function (e) {
          //var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var compenso = +grid.editModule.formObj.element[columnCompensoId].value;
          var costoDitta = +grid.editModule.formObj.element[columnCostoDittaId].value;
          var totale = compenso + costoDitta;
          grid.editModule.formObj.element[columnTotaleId].value = totale;
        });
        
      }

    },
    gridAqueryCellInfo: function (args) {
      // tolta perchè mi riaggiornava la formula
      // if (args.column.field === "totale") {
      //   var totale = args.data.compenso + args.data.costoDitta;
      //   args.data.totale = totale;          //here we have calculated the Total price and updated the value to datasource 
      //   args.cell.innerText = totale;      //here we have set the Total price to the cell value for UI changes 
      //}
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },


  },
  computed: {
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}
</style>
